export default "__VITE_PUBLIC_ASSET__5a163a03__"